"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeavyApi = exports.WeavyApiFactory = exports.WeavyApiFp = exports.WeavyApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * WeavyApi - axios parameter creator
 * @export
 */
const WeavyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create weavy chat
         * @param {InputCreateWeavyChat} [inputCreateWeavyChat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeavyChat: (inputCreateWeavyChat, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/weavy/chat/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputCreateWeavyChat, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all user chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserChats: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/weavy/chat/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get weavy access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeavyAccessToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/weavy/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WeavyApiAxiosParamCreator = WeavyApiAxiosParamCreator;
/**
 * WeavyApi - functional programming interface
 * @export
 */
const WeavyApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WeavyApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create weavy chat
         * @param {InputCreateWeavyChat} [inputCreateWeavyChat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeavyChat(inputCreateWeavyChat, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createWeavyChat(inputCreateWeavyChat, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all user chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserChats(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllUserChats(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get weavy access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeavyAccessToken(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWeavyAccessToken(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WeavyApiFp = WeavyApiFp;
/**
 * WeavyApi - factory interface
 * @export
 */
const WeavyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WeavyApiFp)(configuration);
    return {
        /**
         *
         * @summary Create weavy chat
         * @param {InputCreateWeavyChat} [inputCreateWeavyChat]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWeavyChat(inputCreateWeavyChat, options) {
            return localVarFp.createWeavyChat(inputCreateWeavyChat, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all user chats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUserChats(options) {
            return localVarFp.getAllUserChats(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get weavy access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeavyAccessToken(options) {
            return localVarFp.getWeavyAccessToken(options).then((request) => request(axios, basePath));
        },
    };
};
exports.WeavyApiFactory = WeavyApiFactory;
/**
 * WeavyApi - object-oriented interface
 * @export
 * @class WeavyApi
 * @extends {BaseAPI}
 */
class WeavyApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create weavy chat
     * @param {InputCreateWeavyChat} [inputCreateWeavyChat]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeavyApi
     */
    createWeavyChat(inputCreateWeavyChat, options) {
        return (0, exports.WeavyApiFp)(this.configuration).createWeavyChat(inputCreateWeavyChat, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all user chats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeavyApi
     */
    getAllUserChats(options) {
        return (0, exports.WeavyApiFp)(this.configuration).getAllUserChats(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get weavy access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeavyApi
     */
    getWeavyAccessToken(options) {
        return (0, exports.WeavyApiFp)(this.configuration).getWeavyAccessToken(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WeavyApi = WeavyApi;
